import type { FC, ReactNode } from 'react'
import type { DropdownProps } from '@/tools/ui'
import { Dropdown } from '@/tools/ui'

interface DropdownHeaderProps extends Omit<DropdownProps, 'title'> {
  title?: ReactNode
}

export const DropdownHeader: FC<DropdownHeaderProps> = ({ title, ...props }) => {
  const overridenDropdownProps = {
    ...props,
    title: title as string,
  }
  return <Dropdown {...overridenDropdownProps} />
}
